var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "th",
    {
      class: [_vm.classes],
      attrs: { col_key: _vm.col_key },
      on: {
        click: function ($event) {
          return _vm.$parent.sortCol(_vm.col_key)
        },
      },
    },
    [
      _vm._v("\n    " + _vm._s(_vm.text) + "\n    "),
      _vm.sorting_key === _vm.col_key
        ? [
            _vm.sorting_direction === "desc"
              ? _c("i", { staticClass: "fa fa-sort-amount-desc" })
              : _c("i", { staticClass: "fa fa-sort-amount-asc" }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }